import apiService from './apiService';
import { API_ENDPOINTS } from '../config/api';

const cleanParams = (params) => {
  const result = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') result[key] = value;
  });
  return result;
};

class AdminAnalyticsService {
  async getOverviewSummary({ startDate, endDate, providerId, categoryId, county } = {}) {
    return apiService.get(
      API_ENDPOINTS.ADMIN.ANALYTICS.OVERVIEW_SUMMARY,
      cleanParams({ startDate, endDate, providerId, categoryId, county })
    );
  }

  async getOverviewTimeSeries({ startDate, endDate, providerId, categoryId, county } = {}) {
    return apiService.get(
      API_ENDPOINTS.ADMIN.ANALYTICS.OVERVIEW_TIMESERIES,
      cleanParams({ startDate, endDate, providerId, categoryId, county })
    );
  }

  async getCategoryBreakdown({ startDate, endDate } = {}) {
    return apiService.get(API_ENDPOINTS.ADMIN.ANALYTICS.BY_CATEGORY, cleanParams({ startDate, endDate }));
  }

  async getCountyBreakdown({ startDate, endDate } = {}) {
    return apiService.get(API_ENDPOINTS.ADMIN.ANALYTICS.BY_COUNTY, cleanParams({ startDate, endDate }));
  }

  async searchProviders({ search, categoryId, status } = {}) {
    return apiService.get(
      API_ENDPOINTS.ADMIN.ANALYTICS.PROVIDERS_SEARCH,
      cleanParams({ search, categoryId, status })
    );
  }

  async getMarketplaceKpis({ startDate, endDate } = {}) {
    return apiService.get(API_ENDPOINTS.ADMIN.ANALYTICS.MARKETPLACE_KPIS, cleanParams({ startDate, endDate }));
  }
}

const adminAnalyticsService = new AdminAnalyticsService();
export default adminAnalyticsService;
